import * as yup from 'yup'

export const orderLaundryOperation = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  tipoRecepcion: yup.string().required('El tipo de recepción es obligatorio'),
  puntoId: yup.string().required('El punto es obligatorio'),
  nroBoleta: yup.string().when('tipoRecepcion', {
    is: (valorCampoTipoRecepcion) => valorCampoTipoRecepcion === 'MANUAL',
    then: yup.string().required('El número de boleta es obligatorio'),
    otherwise: yup.string(),
  }),
  servicioId: yup.string().required('El servicio es obligatorio'),
  responsable: yup.string().required('El responsable es obligatorio'),
  huespedId: yup.string().when('responsable', {
    is: (valorCampoResponsable) => valorCampoResponsable !== 'COLABORADOR',
    then: yup.string().required('El colaborador es obligatorio'),
    otherwise: yup.string(),
  }),
  colaboradorId: yup.string().when('responsable', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'COLABORADOR',
    then: yup.string().required('El colaborador es obligatorio'),
    otherwise: yup.string(),
  }),
})

export const orderLaundryReception = yup.object().shape({
  lugarRecepcion: yup.string().required('El lugar es obligatorio'),
  fechaRecepcion: yup.string().required('La fecha es obligatorio'),
  fechaProgramada: yup.string().required('La fecha es obligatorio'),
})
